export const linkMoreThanOneAccountData = [
  {
    Question: `How to link up more than one account if I have multiple?`,
    Answer: `To link up multiple accounts, follow these steps:  

        1. Login to MyWM 
  
        2. Go to the Account Management page in your account settings. 
  
        3. Scroll down until you see the "link account section". 
  
        3. Enter the login information for the additional account you want to link.  
  
        4. Click on the Link Account button to complete the process.  
  
        Note: Make sure you are signed in to the correct account before attempting to link another account. Visit our webpage for a video tutorial.`,
  },
]
